// extracted by mini-css-extract-plugin
export default {"pointsContainer":"Points_pointsContainer__vJmk7","detailCard":"Points_detailCard__0vPBG"};